// store/reducers/supplierPendingReducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    vendors: [],
    buys: [],
    chartData: [],
    summary: {
      totalSuppliers: 0,
      totalPendingAmount: 0,
    },
  },
  loading: false,
  error: null,
};

const supplierPendingSlice = createSlice({
  name: "supplierPending",
  initialState,
  reducers: {
    supplierPendingRequest(state) {
      state.loading = true;
      state.error = null;
    },
    supplierPendingSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
       
    },
    supplierPendingFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetSupplierPending(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
    updateSupplierPendingFilters(state, action) {
       
      state.filters = action.payload;
    }
  },
});

// Export actions and reducer
export const {
  supplierPendingRequest,
  supplierPendingSuccess,
  supplierPendingFailure,
  resetSupplierPending,
  updateSupplierPendingFilters,
} = supplierPendingSlice.actions;

export default supplierPendingSlice.reducer;